import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { motion } from 'framer-motion';

interface IIMCLogoProps {
  size?: 'small' | 'medium' | 'large';
  showAlumni?: boolean;
  className?: string;
  alt?: string;
}

const IIMCLogo: React.FC<IIMCLogoProps> = ({ 
  size = 'medium', 
  showAlumni = true,
  className,
  alt = 'IIMC Logo',
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isDark = theme.palette.mode === 'dark';

  // Size configurations
  const sizeConfig = {
    small: {
      logoHeight: isMobile ? 30 : 40,
      fontSize: isMobile ? '0.6rem' : '0.7rem',
      bottom: isMobile ? -6 : -8,
      right: isMobile ? -8 : -10,
    },
    medium: {
      logoHeight: isMobile ? 40 : 60,
      fontSize: isMobile ? '0.7rem' : '0.85rem',
      bottom: isMobile ? -8 : -12,
      right: isMobile ? -12 : -18,
    },
    large: {
      logoHeight: isMobile ? 40 : 80,
      fontSize: isMobile ? '0.7rem' : '.6rem',
      bottom: isMobile ? -8 : 7.5,
      right: isMobile ? -12 : -28,
    },
  };

  const config = sizeConfig[size];

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 0.6, ease: 'easeOut' }}
      className={className}
    >
      <Box sx={{ position: 'relative' }}>
        <Box
          component="img"
          src="/iimc.png"
          alt={alt}
          sx={{
            height: config.logoHeight,
            width: 'auto',
            filter: isDark ? 'brightness(1.1) contrast(1.1)' : 'brightness(1) contrast(1.05)',
            opacity: 0.9,
            transition: 'all 0.3s ease',
            '&:hover': {
              opacity: 1,
              transform: 'scale(1.05)',
            },
          }}
        />
        {showAlumni && !isMobile && (
          <Typography
            variant="caption"
            sx={{
              position: 'absolute',
              bottom: config.bottom,
              right: config.right,
              fontFamily: '"Roboto Mono", "Courier New", monospace',
              fontSize: config.fontSize,
              fontWeight: 600,
              color: isDark ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.95)',
              textShadow: isDark ? '0 1px 3px #000' : '0 1px 3px rgba(0,0,0,0.3)',
              letterSpacing: '0.02em',
              zIndex: 1,
            }}
          >
          </Typography>
        )}
      </Box>
    </motion.div>
  );
};

export default IIMCLogo; 